import Vue from "vue";
import Vuex from "vuex";
import PatientService from "./services/patient";
import UserService from "./services/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    patientCount: "",
    patients: [],
    currentPatient: "",
    user: {},
    eventModalData: {},
    examModalData: {},
    currentProgress: 0,
    archiveProgress: 0,
    currentAppointment: {},
    currentEvent: {},
    currentExam: {},
    editedSeizure: {},
    allowedImageTypes: ["image/jpg", "image/jpeg", "image/png", "image/gif"],
    allowedImageTypesSimple: ["jpg", "jpeg", "png", "gif"],
    allowedVideoTypes: [
      "video/mp4",
      "video/x-flv",
      "video/quicktime",
      "video/3gpp",
      "video/x-msvideo",
      "video/x-ms-wmv",
    ],
    allowedVideoTypesSimple: ["mp4", "flv", "quicktime", "3gpp", "wmv"],
    allowedFileTypes: [
      "image/jpeg",
      "video/mp4",
      "video/x-flv",
      "video/quicktime",
      "video/3gpp",
      "video/x-msvideo",
      "video/x-ms-wmv",
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
      "text/csv",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "audio/mpeg",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    allowedFileTypesSimple: [
      "jpeg",
      "mp4",
      "flv",
      "quicktime",
      "3gpp",
      "wmv",
      "jpeg",
      "png",
      "gif",
      "pdf",
      "csv",
      "mpeg",
      "ppt",
      "xls",
      "xlsx",
    ],
  },
  mutations: {
    setPatients(state, patients) {
      state.patients = patients;
    },
    setUser(state, user) {
      state.user = user;
    },
    setPatientId(state, patientId) {
      state.currentPatient = patientId;
    },
  },
  getters: {
    userLang: (state) => state.user.language || "en",
    selectedPatient: (state) =>
      state.patients.find((p) => {
        return p._id === state.currentPatient;
      }),
  },
  actions: {
    allPatients: async ({ commit }) => {
      let patients = await PatientService.index();
      commit("setPatients", patients.data);
    },
    allPatientsForMobile: async ({ commit }) => {
      let patients = await PatientService.indexForMobile();
      commit("setPatients", patients.data);
    },
    getPatientId: async ({ commit }, patientId) => {
      console.log("aaa");
      console.log(patientId);
      commit("setPatientId", patientId);
    },
    getUser: async ({ commit }) => {
      let user = await UserService.me();
      commit("setUser", user.data);
    },
  },
});
